import { Routes } from '@angular/router';
import { Login } from './login/login';
import { Home } from './home/home';
import { authGuard } from './auth.guard';
import { IncidentComponent } from './incident/incident/incident';
import { IncidentListComponent } from './incident/incident-list/incident-list';
import { IncidentNavigateComponent } from './incident/incident-navigate/incident-navigate';
import { Quote } from './quote/quote';
import { Pricing } from './pricing/pricing';
import { Invoice } from './invoice/invoice';
import { ServiceProvider } from './service-provider/service-provider';
import { SpNetwork } from './service-provider/sp-network/sp-network';
import { Settings } from './settings/settings';
import { FleetIncident } from './fleet-incident/fleet-incident';
import { CustomStock } from './custom-stock/custom-stock';
import { IncidentDatacapture } from './incident/incident-datacapture/incident-datacapture';
import { LogNewBreakdown } from './public/log-new-breakdown/log-new-breakdown';
import { FleetManagement } from './fleet/fleet-management/fleet-management';
import { BdtechUnauthedDash } from './dash/bdtech-unauthed-dash/bdtech-unauthed-dash';
import { FleetNewBreakdown } from './public/fleet-new-breakdown/fleet-new-breakdown';
import { FleetBreakdownList } from './public/fleet-breakdown-list/fleet-breakdown-list';

export const routes: Routes = [
    { path: '', component: FleetIncident, pathMatch: 'full' },
    { path: 'public/log-breakdown', component: FleetIncident },
    { path: 'report-new-breakdown/:incidentId', component: LogNewBreakdown },
    { path: 'new-breakdown/:fleetId/:cvv/:callcentreId', component: FleetNewBreakdown },
    { path: 'breakdowns/:fleetId/:cvv', component: FleetBreakdownList },
    { path: 'action/:incidentId', component: BdtechUnauthedDash },
    { path: 'login', component: Login },
    { path: 'home', component: Home, canActivate: [authGuard] },
    { path: 'incident/new', component: IncidentComponent, canActivate: [authGuard] },
    { path: 'datacapture', component: IncidentDatacapture, canActivate: [authGuard] },
    { path: 'incident/:incidentId', component: IncidentComponent, canActivate: [authGuard] },
    { path: 'incident/navigate/:incidentId', component: IncidentNavigateComponent, canActivate: [authGuard] },
    { path: 'incidents', component: IncidentListComponent, canActivate: [authGuard] },
    { path: 'quote/:quoteId', component: Quote, canActivate: [authGuard] },
    { path: 'pricing', component: Pricing, canActivate: [authGuard] },
    { path: 'invoice/:quoteId', component: Invoice, canActivate: [authGuard] },
    { path: 'custom-stock', component: CustomStock, canActivate: [authGuard] },
    { path: 'service-providers', component: ServiceProvider, canActivate: [authGuard] },
    { path: 'sp-network', component: SpNetwork, canActivate: [authGuard] },
    { path: 'settings', component: Settings, canActivate: [authGuard] },
    { path: 'fleet', component: FleetManagement, canActivate: [authGuard] },
    { path: '**', redirectTo: 'login' } // Wildcard route for a 404 page or redirect
  
];
